import {  GET_FILTER_ASSIGNMENT_LOG, GET_ASSIGNMENT_LOG,  LogGrid } from "../../../Model/Log"

const initState: LogGrid = {
    LogGridResult: null,
    filter: null,
}
//const dispatch = useDispatch();


export const AssignmentLogGridReducer = (state = initState, action: { type: string, payload: LogGrid }) => {
    switch (action.type) {
        case GET_ASSIGNMENT_LOG:
            {
                return { ...state, LogGridResult: action.payload.LogGridResult }
            }
        case GET_FILTER_ASSIGNMENT_LOG:
            return { ...state, filter: action.payload.filter }
        default:
            return state;
    }
}
